import { mediaItems } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="relative py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">精彩预告</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            热门剧集预告片与精彩花絮抢先看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-200/40 border border-background-200/50 hover:border-background-300/60 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-50/30 group-hover:bg-background-50/20 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/80 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-3">
                  <span className="px-2 py-0.5 rounded bg-background-50/80 text-foreground-950 text-xs font-medium whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-1.5 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-2">
                  <i className="ri-eye-line text-xs text-foreground-500"></i>
                  <span className="text-xs text-foreground-500">{item.views}次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}